import { useQuery } from '@tanstack/react-query'
import { QUERY_KEYS } from '@/query-client'
import {
	type HttpGetExperienceVettingVersionsOptions,
	httpGetExperienceVettingVersions
} from '../http/experience-vetting.http'

export const useGetExperienceVettingVersions = ({
	experienceId
}: HttpGetExperienceVettingVersionsOptions['urlParams']) => {
	return useQuery({
		queryKey: [QUERY_KEYS.EXPERIENCE_VETTING_VERSIONS, experienceId],
		queryFn: () =>
			httpGetExperienceVettingVersions({
				urlParams: { experienceId },
				params: { responseType: 'extended' }
			})
	})
}
